import type { SingleOrArray } from '@mntn-dev/utility-types'

export const asArray = <T>(value: SingleOrArray<T>): Array<T> => {
  return Array.isArray(value) ? value : [value]
}
